import BaseTable from './BaseTable';


class PartnerTable extends BaseTable {

}

export default PartnerTable;
